import Twig from '../helpers/twig.extensions';

export class TwigRendererService {

    renderTemplate(twigTemplate: string, data: any): string {
        if (!twigTemplate) {
            return;
        }

        const template = Twig.twig({
            data: twigTemplate
        });
        return template.render({data: data});
    }
}
